import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import * as echarts from 'echarts';
import resize from '@/mixins/resize';
let myChart0 = null;
let myChart1 = null;
let myChart2 = null;
let myChart3 = null;
let myChart4 = null;
import { mapState } from 'vuex';
export default {
  mixins: [resize],
  props: ['panelData', 'itemNum'],
  data() {
    return {
      myChart: null,
      sourceX: ['保险1', '保险2', '保险3'],
      totalSourceNum: 80,
      source: [{
        name: '保险1',
        proportion: 50,
        value: 11
      }, {
        name: '保险2',
        proportion: 30,
        value: 7
      }, {
        name: '保险3',
        proportion: 20,
        value: 4
      }]
    };
  },
  computed: {
    ...mapState({
      locale: state => state.setting.locale
    })
  },
  mounted() {
    this.$nextTick(() => {
      if (this.itemNum == 0) {
        myChart0 = echarts.init(this.$refs.proportionBar);
      } else if (this.itemNum == 1) {
        myChart1 = echarts.init(this.$refs.proportionBar);
      } else if (this.itemNum == 2) {
        myChart2 = echarts.init(this.$refs.proportionBar);
      } else if (this.itemNum == 3) {
        myChart3 = echarts.init(this.$refs.proportionBar);
      } else if (this.itemNum == 4) {
        myChart4 = echarts.init(this.$refs.proportionBar);
      }
      this.initEchart();
    });
  },
  beforeDestroy() {
    if (this.itemNum == 0) {
      myChart0 && myChart0.clear();
    } else if (this.itemNum == 1) {
      myChart1 && myChart1.clear();
    } else if (this.itemNum == 2) {
      myChart2 && myChart2.clear();
    } else if (this.itemNum == 3) {
      myChart3 && myChart3.clear();
    } else if (this.itemNum == 4) {
      myChart4 && myChart4.clear();
    }
  },
  watch: {
    locale: {
      handler() {
        this.initEchart();
      }
    },
    panelData: {
      handler(newArr) {
        if (this.itemNum != null) {
          if (this.itemNum == 0) {
            myChart0 && myChart0.clear();
            myChart0 = echarts.init(this.$refs.proportionBar);
          } else if (this.itemNum == 1) {
            myChart1 && myChart1.clear();
            myChart1 = echarts.init(this.$refs.proportionBar);
          } else if (this.itemNum == 2) {
            myChart2 && myChart2.clear();
            myChart2 = echarts.init(this.$refs.proportionBar);
          } else if (this.itemNum == 3) {
            myChart3 && myChart3.clear();
            myChart3 = echarts.init(this.$refs.proportionBar);
          } else if (this.itemNum == 4) {
            myChart4 && myChart4.clear();
            myChart4 = echarts.init(this.$refs.proportionBar);
          }
          this.$nextTick(() => {
            this.initEchart();
          });
        }
      }
    },
    deep: true
  },
  methods: {
    initEchart() {
      if (this.panelData) {
        this.source = [];
        this.sourceX = [];
        this.totalSourceNum = this.panelData.totalSourceNum;
        if (this.totalSourceNum == 0) {
          this.source = [{
            name: '',
            proportion: 100,
            value: 0
          }];
        } else {
          this.panelData.source.map(item => {
            if (item.value != '0') {
              this.sourceX.push(item.name);
              this.source.push(item);
            }
          });
        }
      }
      let series = [];
      this.source.map(item => {
        let obj = {
          name: item.name,
          type: 'bar',
          barWidth: 16,
          stack: '危货种类占比',
          barMinWidtht: 5,
          itemStyle: {
            borderRadius: 3,
            borderColor: '#fff',
            borderWidth: 0.5
          },
          label: {
            show: false
          },
          data: [{
            value: item.proportion <= 3 ? 3 : item.proportion,
            value1: item.value,
            value2: item.proportion
          }]
        };
        series.push(obj);
      });
      let that = this;
      const option = {
        // color: COLORLIST,
        title: {
          show: true,
          text: this.$t('总数据') + ':' + that.totalSourceNum,
          textStyle: {
            fontSize: 20
          },
          left: '20',
          top: '50'
        },
        grid: {
          left: 20,
          right: 20,
          top: 0
        },
        tooltip: {
          axisPointer: {
            type: 'shadow'
          },
          padding: [2, 10],
          show: true,
          formatter: function (name) {
            return name.marker + that.$t(name.seriesName) + '<br><span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;"></span>' + name.data.value1 + '(' + name.data.value2 + '%)';
          }
        },
        legend: {
          bottom: '10%',
          left: '20',
          textStyle: {
            color: '#89A7AF'
          },
          type: 'scroll',
          data: that.sourceX,
          show: that.totalSourceNum == 0 ? false : true,
          formatter: name => {
            return that.$t(name);
          }
        },
        xAxis: [{
          type: 'value',
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            show: false
          },
          splitLine: {
            show: false
          }
        }],
        yAxis: [{
          type: 'category',
          data: [''],
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            textStyle: {
              color: '#fff'
            }
          }
        }],
        series: series
      };
      if (this.itemNum == 0) {
        myChart0.setOption(option, true);
      } else if (this.itemNum == 1) {
        myChart1.setOption(option, true);
      } else if (this.itemNum == 2) {
        myChart2.setOption(option, true);
      } else if (this.itemNum == 3) {
        myChart3.setOption(option, true);
      } else if (this.itemNum == 4) {
        myChart4.setOption(option, true);
      }
    }
  }
};